import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

import PopupModal from 'Shared/Components/PopupModal'
import { apiUrl, webUrl } from 'Shared/utils'

const PlaybackModal = ({ playUrl, toggle }) => {
  const { getAccessTokenSilently, logout } = useAuth0()
    const { project } = useParams()
    
    const [token, setToken] = useState()

  const getToken = async () => {
    try {
      const res = await getAccessTokenSilently({
        scope: "openid offline_access",
        grant: "refresh_token",
        detailedResponse: true
      })
      
      return res.access_token
    }
    catch (e){
      logout({ logoutParams: { returnTo: webUrl } })
    }
  }

  useEffect(() => {
    const init = async() => {
      const token = await getToken()
      setToken(token)
    }

    init()
  }, [])

  return (
    <PopupModal isOpen={playUrl != null} height="80%" width="80%" close toggle={toggle}>
      {token && 
        <div style={{ width: "100%", height: "100%", padding: "5px", overflowX: "hidden", overflowY: "hidden" }}>
          {playUrl && 
            <iframe src={`${playUrl}&project=${project}&token=${token}`} style={{ width: "100%", height: "100%" }}/>
          }
        </div>
      }
    </PopupModal>
  )
}

export default PlaybackModal
